// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
export interface Instance {
  name: string;
  type: InstanceType;
  role: string;
  state: InstanceState;
  engine: string;
  size: null | string;
  region: null | string;
  selectsPerSecond: null | number;
  stateGrouped: Record<InstanceState, number>;
  sizeGrouped: string;
  regionGrouped: string;
  parentName: null | string;
  path: string[];
  children: number;
  level: number;
}

export type InstanceType = 'global' | 'cluster' | 'instance';

export type InstanceState = 'RUNNING' | 'STOPPED' | 'TERMINATED';

export default [
  {
    type: 'cluster',
    name: 'cluster-33387b6c',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'TERMINATED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 4200,
    stateGrouped: { RUNNING: 0, STOPPED: 13, TERMINATED: 3 },
    sizeGrouped: '8 instances',
    regionGrouped: 'us-west-2',
    parentName: null,
    path: ['cluster-33387b6c'],
    children: 15,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-2f527cf1',
    role: 'Replica',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 't2.2xlarge',
    region: 'us-east-2',
    selectsPerSecond: 335,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 't2.2xlarge',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-33387b6c',
    path: ['instance-2f527cf1', 'cluster-33387b6c'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-f78263f1',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-33387b6c',
    path: ['cluster-f78263f1', 'cluster-33387b6c'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-8e6f4560',
    role: 'Replica',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 'c4.2xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 241,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c4.2xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-33387b6c',
    path: ['instance-8e6f4560', 'cluster-33387b6c'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-0ed16cea',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 1362,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 1 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-33387b6c',
    path: ['cluster-0ed16cea', 'cluster-33387b6c'],
    children: 5,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-1e5ca3d1',
    role: 'Replica',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 'm3.xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 309,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-0ed16cea',
    path: ['instance-1e5ca3d1', 'cluster-0ed16cea', 'cluster-33387b6c'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-21b0da0d',
    role: 'Replica',
    engine: 'Oracle',
    state: 'TERMINATED',
    size: 'c3.xlarge',
    region: 'us-east-2',
    selectsPerSecond: 9,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'c3.xlarge',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-0ed16cea',
    path: ['instance-21b0da0d', 'cluster-0ed16cea', 'cluster-33387b6c'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-bb31b8ea',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2b',
    selectsPerSecond: 522,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-0ed16cea',
    path: ['cluster-bb31b8ea', 'cluster-0ed16cea', 'cluster-33387b6c'],
    children: 2,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-46a2b83c',
    role: 'Writer',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 't2.2xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 244,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 't2.2xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-bb31b8ea',
    path: ['instance-46a2b83c', 'cluster-bb31b8ea', 'cluster-0ed16cea', 'cluster-33387b6c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-614c5bd5',
    role: 'Replica',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 'c5.large',
    region: 'us-east-1b',
    selectsPerSecond: 278,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c5.large',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-bb31b8ea',
    path: ['instance-614c5bd5', 'cluster-bb31b8ea', 'cluster-0ed16cea', 'cluster-33387b6c'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-7d0bb2e9',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 450,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 1 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-33387b6c',
    path: ['cluster-7d0bb2e9', 'cluster-33387b6c'],
    children: 5,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-8be98e8a',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 56,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 1 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-7d0bb2e9',
    path: ['cluster-8be98e8a', 'cluster-7d0bb2e9', 'cluster-33387b6c'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-138ceae8',
    role: 'Writer',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 'c3.xlarge',
    region: 'us-west-2a',
    selectsPerSecond: 56,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c3.xlarge',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-8be98e8a',
    path: ['instance-138ceae8', 'cluster-8be98e8a', 'cluster-7d0bb2e9', 'cluster-33387b6c'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-a5053a04',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2a',
    selectsPerSecond: 169,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-7d0bb2e9',
    path: ['cluster-a5053a04', 'cluster-7d0bb2e9', 'cluster-33387b6c'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-fba7adf6',
    role: 'Replica',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 'm5.2xlarge',
    region: 'us-west-2a',
    selectsPerSecond: 169,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm5.2xlarge',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-a5053a04',
    path: ['instance-fba7adf6', 'cluster-a5053a04', 'cluster-7d0bb2e9', 'cluster-33387b6c'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-9dfd5e96',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-7d0bb2e9',
    path: ['cluster-9dfd5e96', 'cluster-7d0bb2e9', 'cluster-33387b6c'],
    children: 0,
    level: 3,
  },
  {
    type: 'global',
    name: 'global-57f5713c',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'TERMINATED',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 0, STOPPED: 6, TERMINATED: 1 },
    sizeGrouped: '',
    regionGrouped: '5 regions',
    parentName: null,
    path: ['global-57f5713c'],
    children: 6,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-c6a5dd09',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 145,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'global-57f5713c',
    path: ['cluster-c6a5dd09', 'global-57f5713c'],
    children: 2,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-6d12af68',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5d.xlarge',
    region: 'us-east-1',
    selectsPerSecond: 90,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.xlarge',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-c6a5dd09',
    path: ['instance-6d12af68', 'cluster-c6a5dd09', 'global-57f5713c'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-9d2ac156',
    role: 'Reader',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5d.xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 55,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-c6a5dd09',
    path: ['instance-9d2ac156', 'cluster-c6a5dd09', 'global-57f5713c'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-f7105778',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 817,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'global-57f5713c',
    path: ['cluster-f7105778', 'global-57f5713c'],
    children: 2,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-6089f455',
    role: 'Writer',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'm5.xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 417,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm5.xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-f7105778',
    path: ['instance-6089f455', 'cluster-f7105778', 'global-57f5713c'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-afd62008',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'c5.4xlarge ',
    region: 'us-east-2b',
    selectsPerSecond: 400,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c5.4xlarge ',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-f7105778',
    path: ['instance-afd62008', 'cluster-f7105778', 'global-57f5713c'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-0cc81a50',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 2446,
    stateGrouped: { RUNNING: 0, STOPPED: 7, TERMINATED: 1 },
    sizeGrouped: '5 instances',
    regionGrouped: 'us-west-2',
    parentName: null,
    path: ['cluster-0cc81a50'],
    children: 7,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-aa82b216',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'm4.xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 102,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-0cc81a50',
    path: ['instance-aa82b216', 'cluster-0cc81a50'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-e152f804',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 924,
    stateGrouped: { RUNNING: 0, STOPPED: 4, TERMINATED: 1 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-0cc81a50',
    path: ['cluster-e152f804', 'cluster-0cc81a50'],
    children: 4,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-40a954ce',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2b',
    selectsPerSecond: 261,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 1 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-e152f804',
    path: ['cluster-40a954ce', 'cluster-e152f804', 'cluster-0cc81a50'],
    children: 2,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-f9090f6f',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'r5d.2xlarge',
    region: 'us-east-2',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.2xlarge',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-40a954ce',
    path: ['instance-f9090f6f', 'cluster-40a954ce', 'cluster-e152f804', 'cluster-0cc81a50'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-97661c22',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'TERMINATED',
    size: 'r5.large',
    region: 'us-west-1a',
    selectsPerSecond: 261,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'r5.large',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-40a954ce',
    path: ['instance-97661c22', 'cluster-40a954ce', 'cluster-e152f804', 'cluster-0cc81a50'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-38bf8592',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'r5d.xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 402,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-e152f804',
    path: ['instance-38bf8592', 'cluster-e152f804', 'cluster-0cc81a50'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-c2b848a6',
    role: 'Writer',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'c3.large',
    region: 'us-east-1b',
    selectsPerSecond: 496,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c3.large',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-0cc81a50',
    path: ['instance-c2b848a6', 'cluster-0cc81a50'],
    children: 0,
    level: 2,
  },
  {
    type: 'global',
    name: 'global-6f2b4173',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 2, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '',
    regionGrouped: '1 regions',
    parentName: null,
    path: ['global-6f2b4173'],
    children: 1,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-0ef53740',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'global-6f2b4173',
    path: ['cluster-0ef53740', 'global-6f2b4173'],
    children: 0,
    level: 2,
  },
  {
    type: 'global',
    name: 'global-2f1f1fa4',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 4, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '',
    regionGrouped: '3 regions',
    parentName: null,
    path: ['global-2f1f1fa4'],
    children: 4,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-94ba5e24',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2b',
    selectsPerSecond: 793,
    stateGrouped: { RUNNING: 3, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-west-2b',
    parentName: 'global-2f1f1fa4',
    path: ['cluster-94ba5e24', 'global-2f1f1fa4'],
    children: 3,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-857e8025',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'm4.4xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 228,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm4.4xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-94ba5e24',
    path: ['instance-857e8025', 'cluster-94ba5e24', 'global-2f1f1fa4'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-c135c4f8',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'u-6tb1.metal',
    region: 'us-east-2a',
    selectsPerSecond: 254,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'u-6tb1.metal',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-94ba5e24',
    path: ['instance-c135c4f8', 'cluster-94ba5e24', 'global-2f1f1fa4'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-0d1cc03f',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5d.16xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 311,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.16xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-94ba5e24',
    path: ['instance-0d1cc03f', 'cluster-94ba5e24', 'global-2f1f1fa4'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-3b96a9a0',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 1987,
    stateGrouped: { RUNNING: 8, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '5 instances',
    regionGrouped: 'us-east-1b',
    parentName: null,
    path: ['cluster-3b96a9a0'],
    children: 7,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-3d267758',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'r5.metal',
    region: 'us-west-1a',
    selectsPerSecond: 440,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5.metal',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-3b96a9a0',
    path: ['instance-3d267758', 'cluster-3b96a9a0'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-dfd69003',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 't2.xlarge',
    region: 'us-west-1',
    selectsPerSecond: 184,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 't2.xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-3b96a9a0',
    path: ['instance-dfd69003', 'cluster-3b96a9a0'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-1f429a76',
    role: 'Writer',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'u-6tb1.metal',
    region: 'us-east-1a',
    selectsPerSecond: 459,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'u-6tb1.metal',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-3b96a9a0',
    path: ['instance-1f429a76', 'cluster-3b96a9a0'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-ee8d0804',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-east-2a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-3b96a9a0',
    path: ['cluster-ee8d0804', 'cluster-3b96a9a0'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-2cc3ccce',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 452,
    stateGrouped: { RUNNING: 3, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-3b96a9a0',
    path: ['cluster-2cc3ccce', 'cluster-3b96a9a0'],
    children: 2,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-87fc9060',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 't2.2xlarge',
    region: 'us-west-1',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 't2.2xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-2cc3ccce',
    path: ['instance-87fc9060', 'cluster-2cc3ccce', 'cluster-3b96a9a0'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-24b5d5ea',
    role: 'Reader',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'm4.large',
    region: 'us-west-2',
    selectsPerSecond: 452,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm4.large',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-2cc3ccce',
    path: ['instance-24b5d5ea', 'cluster-2cc3ccce', 'cluster-3b96a9a0'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-86735ea7',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1b',
    selectsPerSecond: 3903,
    stateGrouped: { RUNNING: 3, STOPPED: 8, TERMINATED: 4 },
    sizeGrouped: '8 instances',
    regionGrouped: 'us-west-1b',
    parentName: null,
    path: ['cluster-86735ea7'],
    children: 14,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-ca302542',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-2b',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-86735ea7',
    path: ['cluster-ca302542', 'cluster-86735ea7'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-e66d6fda',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 1706,
    stateGrouped: { RUNNING: 0, STOPPED: 6, TERMINATED: 2 },
    sizeGrouped: '5 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-86735ea7',
    path: ['cluster-e66d6fda', 'cluster-86735ea7'],
    children: 7,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-3b97b85f',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'cr1.8xlarge',
    region: 'us-west-1',
    selectsPerSecond: 162,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'cr1.8xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-e66d6fda',
    path: ['instance-3b97b85f', 'cluster-e66d6fda', 'cluster-86735ea7'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-620371d0',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'TERMINATED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-e66d6fda',
    path: ['cluster-620371d0', 'cluster-e66d6fda', 'cluster-86735ea7'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-b7c552eb',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 772,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-e66d6fda',
    path: ['cluster-b7c552eb', 'cluster-e66d6fda', 'cluster-86735ea7'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-df9c6df2',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'r5.large',
    region: 'us-east-2',
    selectsPerSecond: 222,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.large',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-b7c552eb',
    path: ['instance-df9c6df2', 'cluster-b7c552eb', 'cluster-e66d6fda', 'cluster-86735ea7'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-03ed3c3f',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'r5d.metal',
    region: 'us-west-2a',
    selectsPerSecond: 174,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.metal',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-b7c552eb',
    path: ['instance-03ed3c3f', 'cluster-b7c552eb', 'cluster-e66d6fda', 'cluster-86735ea7'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-2f077be2',
    role: 'Reader',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'm5.2xlarge',
    region: 'us-west-2',
    selectsPerSecond: 360,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm5.2xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-b7c552eb',
    path: ['instance-2f077be2', 'cluster-b7c552eb', 'cluster-e66d6fda', 'cluster-86735ea7'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-edb15b3c',
    role: 'Reader',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'm4.xlarge',
    region: 'us-east-1a',
    selectsPerSecond: 16,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.xlarge',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-b7c552eb',
    path: ['instance-edb15b3c', 'cluster-b7c552eb', 'cluster-e66d6fda', 'cluster-86735ea7'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-18bb19eb',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 127,
    stateGrouped: { RUNNING: 2, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-86735ea7',
    path: ['cluster-18bb19eb', 'cluster-86735ea7'],
    children: 2,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-8e3aa1d8',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'RUNNING',
    size: 'm3.xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 49,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm3.xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-18bb19eb',
    path: ['instance-8e3aa1d8', 'cluster-18bb19eb', 'cluster-86735ea7'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-2095c1c0',
    role: 'Reader',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 't2.2xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 78,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 't2.2xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-18bb19eb',
    path: ['instance-2095c1c0', 'cluster-18bb19eb', 'cluster-86735ea7'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-761e3309',
    role: 'Reader',
    engine: 'Microsoft SQL Server',
    state: 'TERMINATED',
    size: 'r5.metal',
    region: 'us-west-2a',
    selectsPerSecond: 237,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'r5.metal',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-86735ea7',
    path: ['instance-761e3309', 'cluster-86735ea7'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-59c1359f',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-86735ea7',
    path: ['cluster-59c1359f', 'cluster-86735ea7'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-6caaede2',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'TERMINATED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 134,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 1 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-west-2',
    parentName: null,
    path: ['cluster-6caaede2'],
    children: 2,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-3871f7f4',
    role: 'Writer',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'm4.large',
    region: 'us-west-1',
    selectsPerSecond: 134,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.large',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-6caaede2',
    path: ['instance-3871f7f4', 'cluster-6caaede2'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-e2a9f202',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2b',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-6caaede2',
    path: ['cluster-e2a9f202', 'cluster-6caaede2'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-06bc7aea',
    role: 'Instance',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 't2.small',
    region: 'us-west-1',
    selectsPerSecond: 168,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 't2.small',
    regionGrouped: 'us-west-1',
    parentName: null,
    path: ['instance-06bc7aea'],
    children: 0,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-ce707785',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1',
    selectsPerSecond: 1108,
    stateGrouped: { RUNNING: 0, STOPPED: 6, TERMINATED: 0 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-west-1',
    parentName: null,
    path: ['cluster-ce707785'],
    children: 5,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-7c09f69b',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-ce707785',
    path: ['cluster-7c09f69b', 'cluster-ce707785'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-40b8dd6e',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 441,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-ce707785',
    path: ['cluster-40b8dd6e', 'cluster-ce707785'],
    children: 1,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-41685df2',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'm3.large',
    region: 'us-west-1a',
    selectsPerSecond: 441,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.large',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-40b8dd6e',
    path: ['instance-41685df2', 'cluster-40b8dd6e', 'cluster-ce707785'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-24e558a1',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'p2.xlarge',
    region: 'us-west-1',
    selectsPerSecond: 28,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'p2.xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-ce707785',
    path: ['instance-24e558a1', 'cluster-ce707785'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-89dae5f6',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'c4.2xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 198,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c4.2xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-ce707785',
    path: ['instance-89dae5f6', 'cluster-ce707785'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-6d07f8ce',
    role: 'Instance',
    engine: 'MySQL',
    state: 'RUNNING',
    size: 'm4.4xlarge',
    region: 'us-east-1',
    selectsPerSecond: 350,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm4.4xlarge',
    regionGrouped: 'us-east-1',
    parentName: null,
    path: ['instance-6d07f8ce'],
    children: 0,
    level: 1,
  },
  {
    type: 'global',
    name: 'global-26f3b5a3',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '',
    regionGrouped: '1 regions',
    parentName: null,
    path: ['global-26f3b5a3'],
    children: 1,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-b9c8e366',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'global-26f3b5a3',
    path: ['cluster-b9c8e366', 'global-26f3b5a3'],
    children: 0,
    level: 2,
  },
  {
    type: 'global',
    name: 'global-10d0d3a4',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 4, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '',
    regionGrouped: '3 regions',
    parentName: null,
    path: ['global-10d0d3a4'],
    children: 3,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-b39371ed',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-east-2a',
    selectsPerSecond: 564,
    stateGrouped: { RUNNING: 3, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-2a',
    parentName: 'global-10d0d3a4',
    path: ['cluster-b39371ed', 'global-10d0d3a4'],
    children: 2,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-e2e4bb8e',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'c3.large',
    region: 'us-west-1b',
    selectsPerSecond: 332,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'c3.large',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-b39371ed',
    path: ['instance-e2e4bb8e', 'cluster-b39371ed', 'global-10d0d3a4'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-0265d3f3',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'i3.xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 232,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'i3.xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-b39371ed',
    path: ['instance-0265d3f3', 'cluster-b39371ed', 'global-10d0d3a4'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-dcc7fde6',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 2459,
    stateGrouped: { RUNNING: 2, STOPPED: 12, TERMINATED: 1 },
    sizeGrouped: '6 instances',
    regionGrouped: 'us-east-2',
    parentName: null,
    path: ['cluster-dcc7fde6'],
    children: 14,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-a11912e7',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-dcc7fde6',
    path: ['cluster-a11912e7', 'cluster-dcc7fde6'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-dcf4cb46',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 475,
    stateGrouped: { RUNNING: 0, STOPPED: 6, TERMINATED: 0 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-dcc7fde6',
    path: ['cluster-dcf4cb46', 'cluster-dcc7fde6'],
    children: 5,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-0b371633',
    role: 'Writer',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'u-6tb1.metal',
    region: 'us-west-1a',
    selectsPerSecond: 283,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'u-6tb1.metal',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-dcf4cb46',
    path: ['instance-0b371633', 'cluster-dcf4cb46', 'cluster-dcc7fde6'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-f40dc344',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 86,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-dcf4cb46',
    path: ['cluster-f40dc344', 'cluster-dcf4cb46', 'cluster-dcc7fde6'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-8dcdd157',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'm3.2xlarge',
    region: 'us-west-1b',
    selectsPerSecond: 86,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.2xlarge',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-f40dc344',
    path: ['instance-8dcdd157', 'cluster-f40dc344', 'cluster-dcf4cb46', 'cluster-dcc7fde6'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-b439d7b3',
    role: 'Writer',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5d.12xlarge',
    region: 'us-west-2a',
    selectsPerSecond: 20,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.12xlarge',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-dcf4cb46',
    path: ['instance-b439d7b3', 'cluster-dcf4cb46', 'cluster-dcc7fde6'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-d1e766c3',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2b',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-dcf4cb46',
    path: ['cluster-d1e766c3', 'cluster-dcf4cb46', 'cluster-dcc7fde6'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-c16a93ef',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-dcc7fde6',
    path: ['cluster-c16a93ef', 'cluster-dcc7fde6'],
    children: 1,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-666639fa',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1b',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-c16a93ef',
    path: ['cluster-666639fa', 'cluster-c16a93ef', 'cluster-dcc7fde6'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-6423b1e2',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 667,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 1 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-dcc7fde6',
    path: ['cluster-6423b1e2', 'cluster-dcc7fde6'],
    children: 3,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-fbb5d83a',
    role: 'Writer',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 't2.xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 343,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 't2.xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-6423b1e2',
    path: ['instance-fbb5d83a', 'cluster-6423b1e2', 'cluster-dcc7fde6'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-fcbb1a2d',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'i3.large',
    region: 'us-west-1a',
    selectsPerSecond: 324,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.large',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-6423b1e2',
    path: ['instance-fcbb1a2d', 'cluster-6423b1e2', 'cluster-dcc7fde6'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-1fc5f149',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-6423b1e2',
    path: ['cluster-1fc5f149', 'cluster-6423b1e2', 'cluster-dcc7fde6'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-a33ed99f',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 't2.xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 175,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 't2.xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-dcc7fde6',
    path: ['instance-a33ed99f', 'cluster-dcc7fde6'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-5be131e0',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1b',
    selectsPerSecond: 7034,
    stateGrouped: { RUNNING: 1, STOPPED: 12, TERMINATED: 1 },
    sizeGrouped: '9 instances',
    regionGrouped: 'us-west-1b',
    parentName: null,
    path: ['cluster-5be131e0'],
    children: 13,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-7bf22ecb',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-5be131e0',
    path: ['cluster-7bf22ecb', 'cluster-5be131e0'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-b66dbf01',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-2b',
    selectsPerSecond: 745,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 1 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-5be131e0',
    path: ['cluster-b66dbf01', 'cluster-5be131e0'],
    children: 3,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-d68a6e09',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'm3.2xlarge',
    region: 'us-west-2a',
    selectsPerSecond: 330,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.2xlarge',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-b66dbf01',
    path: ['instance-d68a6e09', 'cluster-b66dbf01', 'cluster-5be131e0'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-7fe2be1e',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'c5.large',
    region: 'us-east-2a',
    selectsPerSecond: 300,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c5.large',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-b66dbf01',
    path: ['instance-7fe2be1e', 'cluster-b66dbf01', 'cluster-5be131e0'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-cce122a4',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5d.12xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 115,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.12xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-b66dbf01',
    path: ['instance-cce122a4', 'cluster-b66dbf01', 'cluster-5be131e0'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-39e0774a',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 2772,
    stateGrouped: { RUNNING: 0, STOPPED: 8, TERMINATED: 0 },
    sizeGrouped: '6 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-5be131e0',
    path: ['cluster-39e0774a', 'cluster-5be131e0'],
    children: 7,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-a7363c07',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'c4.2xlarge',
    region: 'us-east-2',
    selectsPerSecond: 88,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c4.2xlarge',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-39e0774a',
    path: ['instance-a7363c07', 'cluster-39e0774a', 'cluster-5be131e0'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-5d674708',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 1209,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-39e0774a',
    path: ['cluster-5d674708', 'cluster-39e0774a', 'cluster-5be131e0'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-48732126',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'c3.large',
    region: 'us-west-1a',
    selectsPerSecond: 309,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c3.large',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-5d674708',
    path: ['instance-48732126', 'cluster-5d674708', 'cluster-39e0774a', 'cluster-5be131e0'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-29a8907d',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5d.2xlarge',
    region: 'us-east-2',
    selectsPerSecond: 174,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.2xlarge',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-5d674708',
    path: ['instance-29a8907d', 'cluster-5d674708', 'cluster-39e0774a', 'cluster-5be131e0'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-b2c33431',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5.2xlarge',
    region: 'us-east-2a',
    selectsPerSecond: 283,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.2xlarge',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-5d674708',
    path: ['instance-b2c33431', 'cluster-5d674708', 'cluster-39e0774a', 'cluster-5be131e0'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-4465d6b1',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5.metal',
    region: 'us-west-1',
    selectsPerSecond: 443,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.metal',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-5d674708',
    path: ['instance-4465d6b1', 'cluster-5d674708', 'cluster-39e0774a', 'cluster-5be131e0'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-f9d34c68',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'm4.large',
    region: 'us-east-1',
    selectsPerSecond: 266,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.large',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-39e0774a',
    path: ['instance-f9d34c68', 'cluster-39e0774a', 'cluster-5be131e0'],
    children: 0,
    level: 3,
  },
  {
    type: 'global',
    name: 'global-e51cfc11',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 2, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '',
    regionGrouped: '1 regions',
    parentName: null,
    path: ['global-e51cfc11'],
    children: 1,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-31e3f463',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'global-e51cfc11',
    path: ['cluster-31e3f463', 'global-e51cfc11'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-29214f8d',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2a',
    selectsPerSecond: 7748,
    stateGrouped: { RUNNING: 0, STOPPED: 13, TERMINATED: 0 },
    sizeGrouped: '7 instances',
    regionGrouped: 'us-west-2a',
    parentName: null,
    path: ['cluster-29214f8d'],
    children: 12,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-f96cced2',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 2780,
    stateGrouped: { RUNNING: 0, STOPPED: 8, TERMINATED: 0 },
    sizeGrouped: '5 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-29214f8d',
    path: ['cluster-f96cced2', 'cluster-29214f8d'],
    children: 7,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-d7c06fe7',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1b',
    selectsPerSecond: 180,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-f96cced2',
    path: ['cluster-d7c06fe7', 'cluster-f96cced2', 'cluster-29214f8d'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-3c73ad1f',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'r5.xlarge',
    region: 'us-west-2a',
    selectsPerSecond: 180,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.xlarge',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-d7c06fe7',
    path: ['instance-3c73ad1f', 'cluster-d7c06fe7', 'cluster-f96cced2', 'cluster-29214f8d'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-1d76025f',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 1210,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-f96cced2',
    path: ['cluster-1d76025f', 'cluster-f96cced2', 'cluster-29214f8d'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-cb2538d5',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'm4.2xlarge',
    region: 'us-west-2',
    selectsPerSecond: 227,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.2xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-1d76025f',
    path: ['instance-cb2538d5', 'cluster-1d76025f', 'cluster-f96cced2', 'cluster-29214f8d'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-e0713341',
    role: 'Writer',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'p2.xlarge',
    region: 'us-west-1b',
    selectsPerSecond: 132,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'p2.xlarge',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-1d76025f',
    path: ['instance-e0713341', 'cluster-1d76025f', 'cluster-f96cced2', 'cluster-29214f8d'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-bbddab69',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'r5d.metal',
    region: 'us-east-1b',
    selectsPerSecond: 387,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.metal',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-1d76025f',
    path: ['instance-bbddab69', 'cluster-1d76025f', 'cluster-f96cced2', 'cluster-29214f8d'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-091b61ac',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'r5d.16xlarge',
    region: 'us-west-1',
    selectsPerSecond: 464,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.16xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-1d76025f',
    path: ['instance-091b61ac', 'cluster-1d76025f', 'cluster-f96cced2', 'cluster-29214f8d'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-7ea68149',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 1094,
    stateGrouped: { RUNNING: 0, STOPPED: 4, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-29214f8d',
    path: ['cluster-7ea68149', 'cluster-29214f8d'],
    children: 3,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-37aab572',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 547,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-7ea68149',
    path: ['cluster-37aab572', 'cluster-7ea68149', 'cluster-29214f8d'],
    children: 2,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-86907efe',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'i3.2xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 442,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.2xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-37aab572',
    path: ['instance-86907efe', 'cluster-37aab572', 'cluster-7ea68149', 'cluster-29214f8d'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-14806fb7',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'r5d.16xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 105,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.16xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-37aab572',
    path: ['instance-14806fb7', 'cluster-37aab572', 'cluster-7ea68149', 'cluster-29214f8d'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-c50dfff5',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 6476,
    stateGrouped: { RUNNING: 12, STOPPED: 2, TERMINATED: 3 },
    sizeGrouped: '9 instances',
    regionGrouped: 'us-east-2',
    parentName: null,
    path: ['cluster-c50dfff5'],
    children: 16,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-42f71ec9',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 1075,
    stateGrouped: { RUNNING: 4, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-c50dfff5',
    path: ['cluster-42f71ec9', 'cluster-c50dfff5'],
    children: 4,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-9656a2d2',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 88,
    stateGrouped: { RUNNING: 2, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-42f71ec9',
    path: ['cluster-9656a2d2', 'cluster-42f71ec9', 'cluster-c50dfff5'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-1145735b',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'c5.large',
    region: 'us-west-1b',
    selectsPerSecond: 88,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'c5.large',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-9656a2d2',
    path: ['instance-1145735b', 'cluster-9656a2d2', 'cluster-42f71ec9', 'cluster-c50dfff5'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-762d0641',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'm3.2xlarge',
    region: 'us-west-2',
    selectsPerSecond: 457,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm3.2xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-42f71ec9',
    path: ['instance-762d0641', 'cluster-42f71ec9', 'cluster-c50dfff5'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-995e55f3',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5d.2xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 442,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.2xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-42f71ec9',
    path: ['instance-995e55f3', 'cluster-42f71ec9', 'cluster-c50dfff5'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-c0323b2d',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 133,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 1 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-c50dfff5',
    path: ['cluster-c0323b2d', 'cluster-c50dfff5'],
    children: 1,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-a4149a85',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5d.12xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 133,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.12xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-c0323b2d',
    path: ['instance-a4149a85', 'cluster-c0323b2d', 'cluster-c50dfff5'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-969c4ff3',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2a',
    selectsPerSecond: 512,
    stateGrouped: { RUNNING: 3, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-c50dfff5',
    path: ['cluster-969c4ff3', 'cluster-c50dfff5'],
    children: 3,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-2f290942',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'r5d.16xlarge',
    region: 'us-east-1',
    selectsPerSecond: 348,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5d.16xlarge',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-969c4ff3',
    path: ['instance-2f290942', 'cluster-969c4ff3', 'cluster-c50dfff5'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-5eb6e410',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-969c4ff3',
    path: ['cluster-5eb6e410', 'cluster-969c4ff3', 'cluster-c50dfff5'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-aff650d1',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'g2.2xlarge',
    region: 'us-west-2',
    selectsPerSecond: 164,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'g2.2xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-969c4ff3',
    path: ['instance-aff650d1', 'cluster-969c4ff3', 'cluster-c50dfff5'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-807d4018',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2b',
    selectsPerSecond: 1518,
    stateGrouped: { RUNNING: 4, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-c50dfff5',
    path: ['cluster-807d4018', 'cluster-c50dfff5'],
    children: 4,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-f88e6cad',
    role: 'Writer',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'm4.10xlarge',
    region: 'us-west-2',
    selectsPerSecond: 88,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm4.10xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-807d4018',
    path: ['instance-f88e6cad', 'cluster-807d4018', 'cluster-c50dfff5'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-958495e9',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 715,
    stateGrouped: { RUNNING: 2, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-807d4018',
    path: ['cluster-958495e9', 'cluster-807d4018', 'cluster-c50dfff5'],
    children: 2,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-9be546c7',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 't2.xlarge',
    region: 'us-east-1',
    selectsPerSecond: 238,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 't2.xlarge',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-958495e9',
    path: ['instance-9be546c7', 'cluster-958495e9', 'cluster-807d4018', 'cluster-c50dfff5'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-acb1c0db',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'TERMINATED',
    size: 'm4.10xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 477,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'm4.10xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-958495e9',
    path: ['instance-acb1c0db', 'cluster-958495e9', 'cluster-807d4018', 'cluster-c50dfff5'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-4c744ef1',
    role: 'Instance',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 't2.small',
    region: 'us-east-1b',
    selectsPerSecond: 138,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 't2.small',
    regionGrouped: 'us-east-1b',
    parentName: null,
    path: ['instance-4c744ef1'],
    children: 0,
    level: 1,
  },
  {
    type: 'global',
    name: 'global-94c17539',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 6, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '',
    regionGrouped: '3 regions',
    parentName: null,
    path: ['global-94c17539'],
    children: 6,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-f647ff08',
    role: 'Reader',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5.large',
    region: 'us-west-1a',
    selectsPerSecond: 44,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.large',
    regionGrouped: 'us-west-1a',
    parentName: 'global-94c17539',
    path: ['instance-f647ff08', 'global-94c17539'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-31e4dc3d',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 234,
    stateGrouped: { RUNNING: 5, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'global-94c17539',
    path: ['cluster-31e4dc3d', 'global-94c17539'],
    children: 4,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-fda602f1',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 117,
    stateGrouped: { RUNNING: 3, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-31e4dc3d',
    path: ['cluster-fda602f1', 'cluster-31e4dc3d', 'global-94c17539'],
    children: 2,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-cff6837d',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'r5.large',
    region: 'us-west-2b',
    selectsPerSecond: 110,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5.large',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-fda602f1',
    path: ['instance-cff6837d', 'cluster-fda602f1', 'cluster-31e4dc3d', 'global-94c17539'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-09d108fb',
    role: 'Reader',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'm4.10xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 7,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm4.10xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-fda602f1',
    path: ['instance-09d108fb', 'cluster-fda602f1', 'cluster-31e4dc3d', 'global-94c17539'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-76dc03d9',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-31e4dc3d',
    path: ['cluster-76dc03d9', 'cluster-31e4dc3d', 'global-94c17539'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-3abb8b8a',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 4096,
    stateGrouped: { RUNNING: 0, STOPPED: 8, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-west-1a',
    parentName: null,
    path: ['cluster-3abb8b8a'],
    children: 7,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-b51312fa',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 2048,
    stateGrouped: { RUNNING: 0, STOPPED: 6, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-3abb8b8a',
    path: ['cluster-b51312fa', 'cluster-3abb8b8a'],
    children: 5,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-90dbb7f7',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 766,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-b51312fa',
    path: ['cluster-90dbb7f7', 'cluster-b51312fa', 'cluster-3abb8b8a'],
    children: 2,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-ba318859',
    role: 'Writer',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'i3.2xlarge',
    region: 'us-west-1',
    selectsPerSecond: 440,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.2xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-90dbb7f7',
    path: ['instance-ba318859', 'cluster-90dbb7f7', 'cluster-b51312fa', 'cluster-3abb8b8a'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-b744dff6',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'm3.large',
    region: 'us-west-1a',
    selectsPerSecond: 326,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.large',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-90dbb7f7',
    path: ['instance-b744dff6', 'cluster-90dbb7f7', 'cluster-b51312fa', 'cluster-3abb8b8a'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-c814a10f',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'r5d.12xlarge',
    region: 'us-east-1a',
    selectsPerSecond: 298,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.12xlarge',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-b51312fa',
    path: ['instance-c814a10f', 'cluster-b51312fa', 'cluster-3abb8b8a'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-96703d43',
    role: 'Replica',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: 'm4.large',
    region: 'us-west-2b',
    selectsPerSecond: 218,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.large',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-b51312fa',
    path: ['instance-96703d43', 'cluster-b51312fa', 'cluster-3abb8b8a'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-00f154e3',
    role: 'Cluster',
    engine: 'PostgreSQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-3abb8b8a',
    path: ['cluster-00f154e3', 'cluster-3abb8b8a'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-c4a42041',
    role: 'Instance',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 'm3.2xlarge',
    region: 'us-east-2a',
    selectsPerSecond: 59,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm3.2xlarge',
    regionGrouped: 'us-east-2a',
    parentName: null,
    path: ['instance-c4a42041'],
    children: 0,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-7e18b53f',
    role: 'Cluster',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 924,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 1 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1b',
    parentName: null,
    path: ['cluster-7e18b53f'],
    children: 2,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-7a06c947',
    role: 'Replica',
    engine: 'Microsoft SQL Server',
    state: 'TERMINATED',
    size: 'c5.4xlarge ',
    region: 'us-west-2b',
    selectsPerSecond: 477,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'c5.4xlarge ',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-7e18b53f',
    path: ['instance-7a06c947', 'cluster-7e18b53f'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-97fbb162',
    role: 'Writer',
    engine: 'Microsoft SQL Server',
    state: 'STOPPED',
    size: 'r5.metal',
    region: 'us-west-1',
    selectsPerSecond: 447,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.metal',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-7e18b53f',
    path: ['instance-97fbb162', 'cluster-7e18b53f'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-0a63a416',
    role: 'Instance',
    engine: 'Oracle',
    state: 'TERMINATED',
    size: 'r5d.16xlarge',
    region: 'us-west-2a',
    selectsPerSecond: 452,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'r5d.16xlarge',
    regionGrouped: 'us-west-2a',
    parentName: null,
    path: ['instance-0a63a416'],
    children: 0,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-3b8f3a7c',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 19121,
    stateGrouped: { RUNNING: 9, STOPPED: 19, TERMINATED: 3 },
    sizeGrouped: '21 instances',
    regionGrouped: 'us-east-2',
    parentName: null,
    path: ['cluster-3b8f3a7c'],
    children: 30,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-6b3d55a2',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-east-2b',
    selectsPerSecond: 543,
    stateGrouped: { RUNNING: 2, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-3b8f3a7c',
    path: ['cluster-6b3d55a2', 'cluster-3b8f3a7c'],
    children: 3,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-8f6e46ed',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 126,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-6b3d55a2',
    path: ['cluster-8f6e46ed', 'cluster-6b3d55a2', 'cluster-3b8f3a7c'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-f23b8016',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'c5.large',
    region: 'us-east-2a',
    selectsPerSecond: 126,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c5.large',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-8f6e46ed',
    path: ['instance-f23b8016', 'cluster-8f6e46ed', 'cluster-6b3d55a2', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-64791614',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'p2.xlarge',
    region: 'us-west-1a',
    selectsPerSecond: 291,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'p2.xlarge',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-6b3d55a2',
    path: ['instance-64791614', 'cluster-6b3d55a2', 'cluster-3b8f3a7c'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-13cda7aa',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 4269,
    stateGrouped: { RUNNING: 0, STOPPED: 11, TERMINATED: 0 },
    sizeGrouped: '8 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-3b8f3a7c',
    path: ['cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 10,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-dc087e30',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5.2xlarge',
    region: 'us-west-1a',
    selectsPerSecond: 189,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.2xlarge',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-13cda7aa',
    path: ['instance-dc087e30', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-a0ed5a89',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 809,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-13cda7aa',
    path: ['cluster-a0ed5a89', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 2,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-25726d89',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'i3.16xlarge',
    region: 'us-west-1b',
    selectsPerSecond: 411,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.16xlarge',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-a0ed5a89',
    path: ['instance-25726d89', 'cluster-a0ed5a89', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-fd954754',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'm3.medium',
    region: 'us-west-1',
    selectsPerSecond: 398,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.medium',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-a0ed5a89',
    path: ['instance-fd954754', 'cluster-a0ed5a89', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-edaab379',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'u-6tb1.metal',
    region: 'us-west-1a',
    selectsPerSecond: 416,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'u-6tb1.metal',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-13cda7aa',
    path: ['instance-edaab379', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-0d3addcb',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 1023,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-13cda7aa',
    path: ['cluster-0d3addcb', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-d538028d',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'm5.xlarge',
    region: 'us-west-2a',
    selectsPerSecond: 253,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm5.xlarge',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-0d3addcb',
    path: ['instance-d538028d', 'cluster-0d3addcb', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-02409f0a',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'm3.xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 250,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-0d3addcb',
    path: ['instance-02409f0a', 'cluster-0d3addcb', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-59bea754',
    role: 'Writer',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 't2.2xlarge',
    region: 'us-west-2',
    selectsPerSecond: 201,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 't2.2xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-0d3addcb',
    path: ['instance-59bea754', 'cluster-0d3addcb', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-fc767da5',
    role: 'Writer',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5.metal',
    region: 'us-west-1',
    selectsPerSecond: 319,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.metal',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-0d3addcb',
    path: ['instance-fc767da5', 'cluster-0d3addcb', 'cluster-13cda7aa', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-f74e13a8',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'TERMINATED',
    size: 'c4.2xlarge',
    region: 'us-west-2',
    selectsPerSecond: 449,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'c4.2xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-3b8f3a7c',
    path: ['instance-f74e13a8', 'cluster-3b8f3a7c'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-55738051',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 4524,
    stateGrouped: { RUNNING: 6, STOPPED: 6, TERMINATED: 2 },
    sizeGrouped: '10 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-3b8f3a7c',
    path: ['cluster-55738051', 'cluster-3b8f3a7c'],
    children: 13,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-66656a6a',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'c5.large',
    region: 'us-west-1',
    selectsPerSecond: 406,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c5.large',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-55738051',
    path: ['instance-66656a6a', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-8c98d7e6',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2b',
    selectsPerSecond: 843,
    stateGrouped: { RUNNING: 4, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-55738051',
    path: ['cluster-8c98d7e6', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-e77aa85b',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'r5.metal',
    region: 'us-west-2',
    selectsPerSecond: 235,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5.metal',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-8c98d7e6',
    path: ['instance-e77aa85b', 'cluster-8c98d7e6', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-3ed1a374',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'r5d.2xlarge',
    region: 'us-west-1',
    selectsPerSecond: 83,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5d.2xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-8c98d7e6',
    path: ['instance-3ed1a374', 'cluster-8c98d7e6', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-e0398a74',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'g2.2xlarge',
    region: 'us-west-1',
    selectsPerSecond: 320,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'g2.2xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-8c98d7e6',
    path: ['instance-e0398a74', 'cluster-8c98d7e6', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-89e7791f',
    role: 'Reader',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'm4.10xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 205,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.10xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-8c98d7e6',
    path: ['instance-89e7791f', 'cluster-8c98d7e6', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-62a22e0c',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 685,
    stateGrouped: { RUNNING: 1, STOPPED: 1, TERMINATED: 1 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-55738051',
    path: ['cluster-62a22e0c', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 2,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-f324c534',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'i3.16xlarge',
    region: 'us-west-1a',
    selectsPerSecond: 192,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.16xlarge',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-62a22e0c',
    path: ['instance-f324c534', 'cluster-62a22e0c', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-2d9d9b05',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'TERMINATED',
    size: 'u-6tb1.metal',
    region: 'us-west-2b',
    selectsPerSecond: 493,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'u-6tb1.metal',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-62a22e0c',
    path: ['instance-2d9d9b05', 'cluster-62a22e0c', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-21381244',
    role: 'Cluster',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1b',
    selectsPerSecond: 531,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 1 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-55738051',
    path: ['cluster-21381244', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 3,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-1cfb5927',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'r5.2xlarge',
    region: 'us-east-1',
    selectsPerSecond: 113,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.2xlarge',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-21381244',
    path: ['instance-1cfb5927', 'cluster-21381244', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-b8f9d782',
    role: 'Writer',
    engine: 'MariaDB',
    state: 'STOPPED',
    size: 'c3.large',
    region: 'us-west-1',
    selectsPerSecond: 16,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c3.large',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-21381244',
    path: ['instance-b8f9d782', 'cluster-21381244', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-a3e814e7',
    role: 'Replica',
    engine: 'MariaDB',
    state: 'TERMINATED',
    size: 't2.xlarge',
    region: 'us-west-1',
    selectsPerSecond: 402,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 't2.xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-21381244',
    path: ['instance-a3e814e7', 'cluster-21381244', 'cluster-55738051', 'cluster-3b8f3a7c'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-18843c68',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2b',
    selectsPerSecond: 8396,
    stateGrouped: { RUNNING: 4, STOPPED: 12, TERMINATED: 2 },
    sizeGrouped: '12 instances',
    regionGrouped: 'us-west-2b',
    parentName: null,
    path: ['cluster-18843c68'],
    children: 17,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-f0fb8a1e',
    role: 'Writer',
    engine: 'MySQL',
    state: 'RUNNING',
    size: 'r5d.metal',
    region: 'us-east-2a',
    selectsPerSecond: 100,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5d.metal',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-18843c68',
    path: ['instance-f0fb8a1e', 'cluster-18843c68'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-a6feccad',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'TERMINATED',
    size: null,
    region: 'us-west-2a',
    selectsPerSecond: 3160,
    stateGrouped: { RUNNING: 0, STOPPED: 9, TERMINATED: 1 },
    sizeGrouped: '7 instances',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-18843c68',
    path: ['cluster-a6feccad', 'cluster-18843c68'],
    children: 9,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-7d3eb1f3',
    role: 'Writer',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'r5d.24xlarge',
    region: 'us-east-2a',
    selectsPerSecond: 252,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.24xlarge',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-a6feccad',
    path: ['instance-7d3eb1f3', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-2bdc09c5',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 1028,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-a6feccad',
    path: ['cluster-2bdc09c5', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-8ca80df9',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'm3.medium',
    region: 'us-west-1b',
    selectsPerSecond: 200,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.medium',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-2bdc09c5',
    path: ['instance-8ca80df9', 'cluster-2bdc09c5', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-3b7d6a68',
    role: 'Writer',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'm3.xlarge',
    region: 'us-west-1b',
    selectsPerSecond: 65,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.xlarge',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-2bdc09c5',
    path: ['instance-3b7d6a68', 'cluster-2bdc09c5', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-876dc8b3',
    role: 'Reader',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'r5d.12xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 291,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.12xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-2bdc09c5',
    path: ['instance-876dc8b3', 'cluster-2bdc09c5', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-a1351bd2',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'm4.10xlarge',
    region: 'us-east-2',
    selectsPerSecond: 472,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.10xlarge',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-2bdc09c5',
    path: ['instance-a1351bd2', 'cluster-2bdc09c5', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-4c2100c5',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 287,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-a6feccad',
    path: ['cluster-4c2100c5', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-0bf31f9a',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'm5.xlarge',
    region: 'us-west-2',
    selectsPerSecond: 287,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm5.xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-4c2100c5',
    path: ['instance-0bf31f9a', 'cluster-4c2100c5', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-ae2e7a7f',
    role: 'Reader',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'm3.2xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 278,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.2xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-a6feccad',
    path: ['instance-ae2e7a7f', 'cluster-a6feccad', 'cluster-18843c68'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-f620dec6',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 988,
    stateGrouped: { RUNNING: 2, STOPPED: 3, TERMINATED: 1 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-18843c68',
    path: ['cluster-f620dec6', 'cluster-18843c68'],
    children: 5,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-a4351011',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 446,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 1 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-f620dec6',
    path: ['cluster-a4351011', 'cluster-f620dec6', 'cluster-18843c68'],
    children: 3,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-63c89c43',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'i3.xlarge',
    region: 'us-east-2a',
    selectsPerSecond: 266,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.xlarge',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-a4351011',
    path: ['instance-63c89c43', 'cluster-a4351011', 'cluster-f620dec6', 'cluster-18843c68'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-3a4e42e2',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'r5d.24xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 99,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.24xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-a4351011',
    path: ['instance-3a4e42e2', 'cluster-a4351011', 'cluster-f620dec6', 'cluster-18843c68'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-9d3923f1',
    role: 'Writer',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'r5d.4xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 81,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.4xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-a4351011',
    path: ['instance-9d3923f1', 'cluster-a4351011', 'cluster-f620dec6', 'cluster-18843c68'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-b25301ac',
    role: 'Replica',
    engine: 'MySQL',
    state: 'RUNNING',
    size: 'r5d.16xlarge',
    region: 'us-east-1a',
    selectsPerSecond: 96,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5d.16xlarge',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-f620dec6',
    path: ['instance-b25301ac', 'cluster-f620dec6', 'cluster-18843c68'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-bcfd0cfa',
    role: 'Instance',
    engine: 'Microsoft SQL Server',
    state: 'RUNNING',
    size: 'r5d.8xlarge',
    region: 'us-west-2',
    selectsPerSecond: 489,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5d.8xlarge',
    regionGrouped: 'us-west-2',
    parentName: null,
    path: ['instance-bcfd0cfa'],
    children: 0,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-c207a8a4',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 8236,
    stateGrouped: { RUNNING: 12, STOPPED: 4, TERMINATED: 0 },
    sizeGrouped: '10 instances',
    regionGrouped: 'us-west-2',
    parentName: null,
    path: ['cluster-c207a8a4'],
    children: 15,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-bfea237a',
    role: 'Reader',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 'm4.large',
    region: 'us-east-2',
    selectsPerSecond: 471,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm4.large',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-c207a8a4',
    path: ['instance-bfea237a', 'cluster-c207a8a4'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-e8916133',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 736,
    stateGrouped: { RUNNING: 3, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-c207a8a4',
    path: ['cluster-e8916133', 'cluster-c207a8a4'],
    children: 4,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-40b0a9e8',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'RUNNING',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-e8916133',
    path: ['cluster-40b0a9e8', 'cluster-e8916133', 'cluster-c207a8a4'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-d155eeaf',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1b',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-e8916133',
    path: ['cluster-d155eeaf', 'cluster-e8916133', 'cluster-c207a8a4'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-e7b1eecf',
    role: 'Writer',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 'i3.xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 452,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-e8916133',
    path: ['instance-e7b1eecf', 'cluster-e8916133', 'cluster-c207a8a4'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-ebd15146',
    role: 'Writer',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 'g2.2xlarge',
    region: 'us-east-1a',
    selectsPerSecond: 284,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'g2.2xlarge',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-e8916133',
    path: ['instance-ebd15146', 'cluster-e8916133', 'cluster-c207a8a4'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-db77b36e',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 3098,
    stateGrouped: { RUNNING: 6, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '6 instances',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-c207a8a4',
    path: ['cluster-db77b36e', 'cluster-c207a8a4'],
    children: 7,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-c2d9eff8',
    role: 'Cluster',
    engine: 'Oracle',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2b',
    selectsPerSecond: 1317,
    stateGrouped: { RUNNING: 3, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-db77b36e',
    path: ['cluster-c2d9eff8', 'cluster-db77b36e', 'cluster-c207a8a4'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-99a07cc5',
    role: 'Reader',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 'c5.4xlarge ',
    region: 'us-east-1',
    selectsPerSecond: 403,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c5.4xlarge ',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-c2d9eff8',
    path: ['instance-99a07cc5', 'cluster-c2d9eff8', 'cluster-db77b36e', 'cluster-c207a8a4'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-08fa89a3',
    role: 'Writer',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 'r5d.metal',
    region: 'us-west-1a',
    selectsPerSecond: 433,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5d.metal',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-c2d9eff8',
    path: ['instance-08fa89a3', 'cluster-c2d9eff8', 'cluster-db77b36e', 'cluster-c207a8a4'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-6ad3e359',
    role: 'Replica',
    engine: 'Oracle',
    state: 'STOPPED',
    size: 'r5d.8xlarge',
    region: 'us-west-1',
    selectsPerSecond: 445,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.8xlarge',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-c2d9eff8',
    path: ['instance-6ad3e359', 'cluster-c2d9eff8', 'cluster-db77b36e', 'cluster-c207a8a4'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-9a68bc04',
    role: 'Replica',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 'p2.xlarge',
    region: 'us-west-2',
    selectsPerSecond: 36,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'p2.xlarge',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-c2d9eff8',
    path: ['instance-9a68bc04', 'cluster-c2d9eff8', 'cluster-db77b36e', 'cluster-c207a8a4'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-2fb3adc2',
    role: 'Replica',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 'i3.16xlarge',
    region: 'us-east-1',
    selectsPerSecond: 32,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'i3.16xlarge',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-db77b36e',
    path: ['instance-2fb3adc2', 'cluster-db77b36e', 'cluster-c207a8a4'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-4de043ac',
    role: 'Replica',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 'i3.16xlarge',
    region: 'us-east-1a',
    selectsPerSecond: 432,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'i3.16xlarge',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-db77b36e',
    path: ['instance-4de043ac', 'cluster-db77b36e', 'cluster-c207a8a4'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-808da828',
    role: 'Replica',
    engine: 'Oracle',
    state: 'RUNNING',
    size: 'c3.xlarge',
    region: 'us-west-2a',
    selectsPerSecond: 97,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'c3.xlarge',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-c207a8a4',
    path: ['instance-808da828', 'cluster-c207a8a4'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-8fbeb949',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 1, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-2',
    parentName: null,
    path: ['cluster-8fbeb949'],
    children: 2,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-a49fd8d8',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-8fbeb949',
    path: ['cluster-a49fd8d8', 'cluster-8fbeb949'],
    children: 1,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-bf23af94',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-a49fd8d8',
    path: ['cluster-bf23af94', 'cluster-a49fd8d8', 'cluster-8fbeb949'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-0b085dbd',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 5031,
    stateGrouped: { RUNNING: 5, STOPPED: 3, TERMINATED: 1 },
    sizeGrouped: '5 instances',
    regionGrouped: 'us-west-1a',
    parentName: null,
    path: ['cluster-0b085dbd'],
    children: 8,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-f112f714',
    role: 'Writer',
    engine: 'MySQL',
    state: 'RUNNING',
    size: 'cr1.8xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 3,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'cr1.8xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-0b085dbd',
    path: ['instance-f112f714', 'cluster-0b085dbd'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-00b6a306',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 2514,
    stateGrouped: { RUNNING: 3, STOPPED: 3, TERMINATED: 1 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-0b085dbd',
    path: ['cluster-00b6a306', 'cluster-0b085dbd'],
    children: 6,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-1a74b98c',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 1076,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 1 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-00b6a306',
    path: ['cluster-1a74b98c', 'cluster-00b6a306', 'cluster-0b085dbd'],
    children: 3,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-cfe7f6f5',
    role: 'Replica',
    engine: 'MySQL',
    state: 'TERMINATED',
    size: 'm5.large',
    region: 'us-west-2b',
    selectsPerSecond: 472,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'm5.large',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-1a74b98c',
    path: ['instance-cfe7f6f5', 'cluster-1a74b98c', 'cluster-00b6a306', 'cluster-0b085dbd'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-274ea053',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'i3.xlarge',
    region: 'us-east-2a',
    selectsPerSecond: 203,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.xlarge',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-1a74b98c',
    path: ['instance-274ea053', 'cluster-1a74b98c', 'cluster-00b6a306', 'cluster-0b085dbd'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-deacbd74',
    role: 'Replica',
    engine: 'MySQL',
    state: 'STOPPED',
    size: 'm4.2xlarge',
    region: 'us-east-1a',
    selectsPerSecond: 401,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.2xlarge',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-1a74b98c',
    path: ['instance-deacbd74', 'cluster-1a74b98c', 'cluster-00b6a306', 'cluster-0b085dbd'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-8aa83e10',
    role: 'Cluster',
    engine: 'MySQL',
    state: 'RUNNING',
    size: null,
    region: 'us-west-2a',
    selectsPerSecond: 181,
    stateGrouped: { RUNNING: 2, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-00b6a306',
    path: ['cluster-8aa83e10', 'cluster-00b6a306', 'cluster-0b085dbd'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-4d633d4e',
    role: 'Replica',
    engine: 'MySQL',
    state: 'RUNNING',
    size: 'm4.large',
    region: 'us-west-1b',
    selectsPerSecond: 181,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm4.large',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-8aa83e10',
    path: ['instance-4d633d4e', 'cluster-8aa83e10', 'cluster-00b6a306', 'cluster-0b085dbd'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-d60356d3',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 904,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-east-1b',
    parentName: null,
    path: ['cluster-d60356d3'],
    children: 4,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-799ad7b6',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1',
    selectsPerSecond: 452,
    stateGrouped: { RUNNING: 0, STOPPED: 4, TERMINATED: 0 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-d60356d3',
    path: ['cluster-799ad7b6', 'cluster-d60356d3'],
    children: 3,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-bed398a0',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 't1.micro',
    region: 'us-west-1b',
    selectsPerSecond: 366,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 't1.micro',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-799ad7b6',
    path: ['instance-bed398a0', 'cluster-799ad7b6', 'cluster-d60356d3'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-2d0ba648',
    role: 'Writer',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'cr1.8xlarge',
    region: 'us-west-1b',
    selectsPerSecond: 86,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'cr1.8xlarge',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-799ad7b6',
    path: ['instance-2d0ba648', 'cluster-799ad7b6', 'cluster-d60356d3'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-be98d076',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-799ad7b6',
    path: ['cluster-be98d076', 'cluster-799ad7b6', 'cluster-d60356d3'],
    children: 0,
    level: 3,
  },
  {
    type: 'global',
    name: 'global-cb027b57',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 0, STOPPED: 27, TERMINATED: 1 },
    sizeGrouped: '',
    regionGrouped: '11 regions',
    parentName: null,
    path: ['global-cb027b57'],
    children: 27,
    level: 1,
  },
  {
    type: 'cluster',
    name: 'cluster-f207ad0d',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1',
    parentName: 'global-cb027b57',
    path: ['cluster-f207ad0d', 'global-cb027b57'],
    children: 0,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-302399aa',
    role: 'Writer',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5.2xlarge',
    region: 'us-west-1b',
    selectsPerSecond: 292,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.2xlarge',
    regionGrouped: 'us-west-1b',
    parentName: 'global-cb027b57',
    path: ['instance-302399aa', 'global-cb027b57'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-7f5d9b75',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1a',
    selectsPerSecond: 951,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 1 },
    sizeGrouped: '2 instances',
    regionGrouped: 'us-west-1a',
    parentName: 'global-cb027b57',
    path: ['cluster-7f5d9b75', 'global-cb027b57'],
    children: 5,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-6225aeef',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'TERMINATED',
    size: null,
    region: 'us-east-2a',
    selectsPerSecond: 365,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 1 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-7f5d9b75',
    path: ['cluster-6225aeef', 'cluster-7f5d9b75', 'global-cb027b57'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-5b503b55',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 't1.micro',
    region: 'us-west-1a',
    selectsPerSecond: 365,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 't1.micro',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-6225aeef',
    path: ['instance-5b503b55', 'cluster-6225aeef', 'cluster-7f5d9b75', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-98046064',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5d.8xlarge',
    region: 'us-west-2b',
    selectsPerSecond: 221,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.8xlarge',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-7f5d9b75',
    path: ['instance-98046064', 'cluster-7f5d9b75', 'global-cb027b57'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-141b271e',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1a',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-east-1a',
    parentName: 'cluster-7f5d9b75',
    path: ['cluster-141b271e', 'cluster-7f5d9b75', 'global-cb027b57'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-04b1b0c4',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-1',
    selectsPerSecond: 0,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: '0 instances',
    regionGrouped: 'us-west-1',
    parentName: 'cluster-7f5d9b75',
    path: ['cluster-04b1b0c4', 'cluster-7f5d9b75', 'global-cb027b57'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-15462c8b',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2b',
    selectsPerSecond: 1874,
    stateGrouped: { RUNNING: 0, STOPPED: 8, TERMINATED: 0 },
    sizeGrouped: '6 instances',
    regionGrouped: 'us-east-2b',
    parentName: 'global-cb027b57',
    path: ['cluster-15462c8b', 'global-cb027b57'],
    children: 7,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-b056fd2c',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2b',
    selectsPerSecond: 852,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-15462c8b',
    path: ['cluster-b056fd2c', 'cluster-15462c8b', 'global-cb027b57'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-aabe2a3c',
    role: 'Reader',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5d.16xlarge',
    region: 'us-east-1',
    selectsPerSecond: 307,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.16xlarge',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-b056fd2c',
    path: ['instance-aabe2a3c', 'cluster-b056fd2c', 'cluster-15462c8b', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-cafb28f3',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5d.4xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 39,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.4xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-b056fd2c',
    path: ['instance-cafb28f3', 'cluster-b056fd2c', 'cluster-15462c8b', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-4aedc9e4',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'm4.4xlarge',
    region: 'us-west-1b',
    selectsPerSecond: 358,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm4.4xlarge',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-b056fd2c',
    path: ['instance-4aedc9e4', 'cluster-b056fd2c', 'cluster-15462c8b', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-13807bc3',
    role: 'Reader',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'c3.large',
    region: 'us-east-1',
    selectsPerSecond: 148,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c3.large',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-b056fd2c',
    path: ['instance-13807bc3', 'cluster-b056fd2c', 'cluster-15462c8b', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-6ffd62a1',
    role: 'Writer',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'm5.2xlarge',
    region: 'us-west-1a',
    selectsPerSecond: 83,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm5.2xlarge',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-15462c8b',
    path: ['instance-6ffd62a1', 'cluster-15462c8b', 'global-cb027b57'],
    children: 0,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-f516acc3',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'i3.16xlarge',
    region: 'us-east-2b',
    selectsPerSecond: 87,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.16xlarge',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-15462c8b',
    path: ['instance-f516acc3', 'cluster-15462c8b', 'global-cb027b57'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-e8b773c6',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2a',
    selectsPerSecond: 5268,
    stateGrouped: { RUNNING: 0, STOPPED: 11, TERMINATED: 0 },
    sizeGrouped: '8 instances',
    regionGrouped: 'us-east-2a',
    parentName: 'global-cb027b57',
    path: ['cluster-e8b773c6', 'global-cb027b57'],
    children: 10,
    level: 2,
  },
  {
    type: 'instance',
    name: 'instance-cc422101',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'c5.large',
    region: 'us-east-1b',
    selectsPerSecond: 36,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c5.large',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-e8b773c6',
    path: ['instance-cc422101', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 0,
    level: 3,
  },
  {
    type: 'cluster',
    name: 'cluster-2f75b05f',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2b',
    selectsPerSecond: 1089,
    stateGrouped: { RUNNING: 0, STOPPED: 4, TERMINATED: 0 },
    sizeGrouped: '3 instances',
    regionGrouped: 'us-west-2b',
    parentName: 'cluster-e8b773c6',
    path: ['cluster-2f75b05f', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 3,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-031b8ac5',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5d.24xlarge',
    region: 'us-east-2',
    selectsPerSecond: 448,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.24xlarge',
    regionGrouped: 'us-east-2',
    parentName: 'cluster-2f75b05f',
    path: ['instance-031b8ac5', 'cluster-2f75b05f', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-2e8e7dba',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 't2.xlarge',
    region: 'us-west-1a',
    selectsPerSecond: 282,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 't2.xlarge',
    regionGrouped: 'us-west-1a',
    parentName: 'cluster-2f75b05f',
    path: ['instance-2e8e7dba', 'cluster-2f75b05f', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-75b7cd27',
    role: 'Writer',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'm3.medium',
    region: 'us-west-1b',
    selectsPerSecond: 359,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'm3.medium',
    regionGrouped: 'us-west-1b',
    parentName: 'cluster-2f75b05f',
    path: ['instance-75b7cd27', 'cluster-2f75b05f', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'cluster',
    name: 'cluster-975d36b6',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-1b',
    selectsPerSecond: 1527,
    stateGrouped: { RUNNING: 0, STOPPED: 5, TERMINATED: 0 },
    sizeGrouped: '4 instances',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-e8b773c6',
    path: ['cluster-975d36b6', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 4,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-15efd7f0',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'c3.large',
    region: 'us-east-2b',
    selectsPerSecond: 475,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c3.large',
    regionGrouped: 'us-east-2b',
    parentName: 'cluster-975d36b6',
    path: ['instance-15efd7f0', 'cluster-975d36b6', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-4523d742',
    role: 'Writer',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5.2xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 442,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5.2xlarge',
    regionGrouped: 'us-east-1b',
    parentName: 'cluster-975d36b6',
    path: ['instance-4523d742', 'cluster-975d36b6', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-1caeb93b',
    role: 'Reader',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'c5.4xlarge ',
    region: 'us-west-2a',
    selectsPerSecond: 340,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'c5.4xlarge ',
    regionGrouped: 'us-west-2a',
    parentName: 'cluster-975d36b6',
    path: ['instance-1caeb93b', 'cluster-975d36b6', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-14371d77',
    role: 'Writer',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'r5d.24xlarge',
    region: 'us-east-2a',
    selectsPerSecond: 270,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'r5d.24xlarge',
    regionGrouped: 'us-east-2a',
    parentName: 'cluster-975d36b6',
    path: ['instance-14371d77', 'cluster-975d36b6', 'cluster-e8b773c6', 'global-cb027b57'],
    children: 0,
    level: 4,
  },
  {
    type: 'global',
    name: 'global-10b34c5c',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 2, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: '',
    regionGrouped: '1 regions',
    parentName: null,
    path: ['global-10b34c5c'],
    children: 1,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-df2b32a9',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'RUNNING',
    size: 'r5d.xlarge',
    region: 'us-east-1a',
    selectsPerSecond: 258,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'r5d.xlarge',
    regionGrouped: 'us-east-1a',
    parentName: 'global-10b34c5c',
    path: ['instance-df2b32a9', 'global-10b34c5c'],
    children: 0,
    level: 2,
  },
  {
    type: 'global',
    name: 'global-4898bb8b',
    role: 'Global',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: null,
    selectsPerSecond: null,
    stateGrouped: { RUNNING: 0, STOPPED: 4, TERMINATED: 1 },
    sizeGrouped: '',
    regionGrouped: '4 regions',
    parentName: null,
    path: ['global-4898bb8b'],
    children: 4,
    level: 1,
  },
  {
    type: 'instance',
    name: 'instance-7a0c4df2',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'TERMINATED',
    size: 'u-6tb1.metal',
    region: 'us-west-1b',
    selectsPerSecond: 464,
    stateGrouped: { RUNNING: 0, STOPPED: 0, TERMINATED: 1 },
    sizeGrouped: 'u-6tb1.metal',
    regionGrouped: 'us-west-1b',
    parentName: 'global-4898bb8b',
    path: ['instance-7a0c4df2', 'global-4898bb8b'],
    children: 0,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-f3120972',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-east-2',
    selectsPerSecond: 580,
    stateGrouped: { RUNNING: 0, STOPPED: 3, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-east-2',
    parentName: 'global-4898bb8b',
    path: ['cluster-f3120972', 'global-4898bb8b'],
    children: 2,
    level: 2,
  },
  {
    type: 'cluster',
    name: 'cluster-d577b6bf',
    role: 'Cluster',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: null,
    region: 'us-west-2',
    selectsPerSecond: 290,
    stateGrouped: { RUNNING: 0, STOPPED: 2, TERMINATED: 0 },
    sizeGrouped: '1 instances',
    regionGrouped: 'us-west-2',
    parentName: 'cluster-f3120972',
    path: ['cluster-d577b6bf', 'cluster-f3120972', 'global-4898bb8b'],
    children: 1,
    level: 3,
  },
  {
    type: 'instance',
    name: 'instance-031ed206',
    role: 'Replica',
    engine: 'Aurora MySQL',
    state: 'STOPPED',
    size: 'i3.large',
    region: 'us-east-1',
    selectsPerSecond: 290,
    stateGrouped: { RUNNING: 0, STOPPED: 1, TERMINATED: 0 },
    sizeGrouped: 'i3.large',
    regionGrouped: 'us-east-1',
    parentName: 'cluster-d577b6bf',
    path: ['instance-031ed206', 'cluster-d577b6bf', 'cluster-f3120972', 'global-4898bb8b'],
    children: 0,
    level: 4,
  },
  {
    type: 'instance',
    name: 'instance-ab6f0e4c',
    role: 'Instance',
    engine: 'MariaDB',
    state: 'RUNNING',
    size: 'm3.xlarge',
    region: 'us-east-1b',
    selectsPerSecond: 164,
    stateGrouped: { RUNNING: 1, STOPPED: 0, TERMINATED: 0 },
    sizeGrouped: 'm3.xlarge',
    regionGrouped: 'us-east-1b',
    parentName: null,
    path: ['instance-ab6f0e4c'],
    children: 0,
    level: 1,
  },
] as ReadonlyArray<Instance>;
